




<template>
<div>
<v-card>
  <v-toolbar dark  color="#4A76A8" flat  height="42">
  <v-icon large>mdi-tune</v-icon>   <v-toolbar-title  >     {{tasks.task.info.name}}   </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="tasks.modals.params = false">mdi-close</v-icon>
  </v-toolbar>

<v-card-text fluid style="height:60vh; overflow-x:hidden">

<v-text-field clearable v-model="tasks.task.name"   color="#4A76A8"   label="Название задания"></v-text-field>

<v-subheader>Минимальная и Максимальная задержка между действиями (сек.)</v-subheader>
<v-card-text>

  <v-layout row>

    <v-flex class="px-3">
      <v-range-slider
      color="#4A76A8"
      thumb-label="always"
        v-model="tasks.task.params.actionsTimeout.range"
        :max="tasks.task.params.actionsTimeout.max"
        :min="tasks.task.params.actionsTimeout.min"
      ></v-range-slider>
    </v-flex>

  </v-layout>
</v-card-text>


<v-subheader>Минимальная и Максимальная задержка между ресурсами (сек.)</v-subheader>
<v-card-text>

  <v-layout row>

    <v-flex class="px-3">
      <v-range-slider
      color="#4A76A8"
      thumb-label="always"
        v-model="tasks.task.params.resourcesTimeout.range"
        :max="tasks.task.params.resourcesTimeout.max"
        :min="tasks.task.params.resourcesTimeout.min"
      ></v-range-slider>
    </v-flex>

  </v-layout>
</v-card-text>










</v-card-text>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn color="#4A76A8" flat small @click.native="tasks.modals.params=false">Закрыть</v-btn>
<v-btn color="#4A76A8" small class="white--text" @click="changeParams()" >Сохранить </v-btn>
</v-card-actions>


</v-card>
</div>
</template>

<script>

import axios from 'axios'
export default {
props:['tasks' ],
  data () {
    return {


    }
  },
methods:{
  changeParams(){


    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_params.php', {
         method: 'POST',
         data: {
           params: this.tasks.task.params,
           name: this.tasks.task.name,
           taskId: this.tasks.task.info.task_id
         }
       })
       .then( response => {
         this.tasksData()
       })


  },
  tasksData: function(){

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
         method: 'POST',
         data: {
           contentType: 'groups'
         }
       })
       .then( response => {
         this.tasks.tasksList = response.data
         this.tasks.modals.params = false

       })

  },


},
beforeDestroy() {

}

}
</script>

<style   >

</style>
